import { uniqBy } from 'lodash-es';
import type { AdSetEntry } from '../api/getAdSets';

export interface UseAdSetBudgetSumsParams {
  selectedAdSets: AdSetEntry[];
  budgets: Record<string, string | number>;
  duplicateCounts: Record<string, string | number>;
}

export interface UseAdSetBudgetSumsResult {
  cboSum: number;
  aboSum: number;
  totalSum: number;
}

export const useAdSetBudgetSums = (
  params: UseAdSetBudgetSumsParams,
): UseAdSetBudgetSumsResult => {
  const { selectedAdSets, budgets, duplicateCounts } = params;

  // Get unique CBO ad sets by campaign_id to avoid double counting
  const cboAdSets = uniqBy(
    selectedAdSets.filter((adSet: AdSetEntry) => adSet.is_cbo),
    'campaign_id',
  );

  // Get all ABO ad sets
  const aboAdSets = selectedAdSets.filter((adSet: AdSetEntry) => !adSet.is_cbo);

  const cboSum = cboAdSets.reduce((total, { id }) => {
    const budget = Number(budgets[id]);
    return isNaN(budget) ? total : total + budget;
  }, 0);

  const aboSum = aboAdSets.reduce((total, { id }) => {
    const budget = Number(budgets[id]);
    const duplicates = Number(duplicateCounts[id]);
    const value = budget * duplicates;
    return isNaN(value) ? total : total + value;
  }, 0);

  const totalSum = cboSum + aboSum;

  return { cboSum, aboSum, totalSum };
};

export default useAdSetBudgetSums;
